import React from "react";
import { useUser } from "../../../../context/AuthContext";
import Scope3ApprovalListCore from "../Scope3ApprovalListCore";
import CapitalGoodsViewPage from "../../CapitalGoodsView";

const CapitalGoodsApproval = () => {
  const { user } = useUser();

  const headings = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin ? { title: "Facility", key: "facilityName" } : null,
    { title: "Purchase Date", key: "purchaseDate" },
    { title: "Capital Good", key: "capitalGoodsName" },
    // { title: "Category", key: "capitalGoodsCategory" },
    { title: "Supplier", key: "supplierName" },
    { title: "Status", key: "requestStatus" },
    { title: "Created By", key: "createdBy" },
  ].filter(Boolean);

  const viewheaders = [{ key: "requestStatus", title: "Status" }];

  return (
    <Scope3ApprovalListCore
      pageTitle="Capital Goods"
      apiSegment="capitalGoodsEmissions"
      ViewPage={CapitalGoodsViewPage}
      headings={headings}
      viewheaders={viewheaders}
      columnWidth={
        user?.companyAdmin
          ? "10% 10% 11% 14% 14% 14% 14% 9%"
          : "11% 12% 15% 16% 16% 16% 8%"
      }
    />
  );
};

export default CapitalGoodsApproval;
